export var LocationSyncStatusEnum;
(function (LocationSyncStatusEnum) {
    LocationSyncStatusEnum["PENDING"] = "pending";
    LocationSyncStatusEnum["IN_PROGRESS"] = "in_progress";
    LocationSyncStatusEnum["COMPLETED"] = "completed";
    LocationSyncStatusEnum["FAILED"] = "failed";
})(LocationSyncStatusEnum || (LocationSyncStatusEnum = {}));
//# sourceMappingURL=LocationSyncStatusEnum.js.map